export const SET_ACTUAL_PROJECT = 'set_actual_scenario';
export const INITIALIZE_PROJECT = 'set_actual_scenario_null';

export type ActionsProject =
  | { type: typeof SET_ACTUAL_PROJECT, payload: any }
  | { type: typeof INITIALIZE_PROJECT, payload: null }

export const setActualProject = (actualScenario):ActionsProject => {
  return { type: SET_ACTUAL_PROJECT, payload: actualScenario };
};

export const initializeProject = ():ActionsProject => {
  return { type: INITIALIZE_PROJECT, payload: null };
};
